import React, { useEffect, useState } from "react";

import routes from "./routes";
import useJumboRoutes from "@jumbo/hooks/useJumboRoutes";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";

const AppRoutes = () => {
    const appRoutes = useJumboRoutes(routes);
    const location = useLocation();
    const jumboco = useJumboAuth();
    const navigate = useNavigate()
    // debugger
    useEffect(() => {
        if (jumboco && jumboco.menuObject?.Gaurd?.length > 0 && location.pathname != '/notauthorised') {
            jumboco.setAuthOptions({ type: "start-loading" });
            let navigatePath = jumboco.menuObject?.Gaurd.filter((g) => g.uri == location.pathname && g.view == 1)
            if (jumboco.menuObject?.Menu && navigatePath?.length > 0) {
                let ndata = navigatePath[0]
                jumboco.setAuthOptions({ type: "page-rights", payload: ndata });
                jumboco.setAuthOptions({ type: "stop-loading" });
            } else {
                let navigatePathDetail = jumboco.menuObject?.Gaurd.filter((g) => g.uri == '/'+location.pathname?.split('/')[1] && g.view == 1)
                if (navigatePathDetail?.length > 0) {
                    let ndata = navigatePathDetail[0]
                    jumboco.setAuthOptions({ type: "page-rights", payload: ndata });
                    jumboco.setAuthOptions({ type: "stop-loading" });
                }else{
                    // navigate('/notauthorised') //--uncomment when in production  disabled for devlopment
                    jumboco.setAuthOptions({ type: "stop-loading" });
                }
            }
        }
    }, [location, jumboco.menuObject])
    return (
        <React.Fragment>
            {
                appRoutes
            }
        </React.Fragment>
    );
};
export default AppRoutes;
